import { TeamInfoDto, TeamLogoDto, TeamManagerDto, TeamOwnerDto, TeamPlayerInfoDto, TeamStatsDto } from '@/infrastructure/network/dto';

export const teamStatsDtoToTeamStats = (teamStats: TeamStatsDto): TeamStatsDto => ({
	systemTeamUuid: teamStats.systemTeamUuid || null,
	divisionUuid: teamStats.divisionUuid || null,
	divisionTitle: teamStats.divisionTitle || null,
	poolUuid: teamStats.poolUuid || null,
	seasonUuid: teamStats.seasonUuid || null,
	seasonTitle: teamStats.seasonTitle || null,
	skillFrom: teamStats.skillFrom ? String(teamStats.skillFrom) : null,
	skillTo: teamStats.skillTo ? String(teamStats.skillTo) : null,
	ageFrom: teamStats.ageFrom ? String(teamStats.ageFrom) : null,
	ageTo: teamStats.ageTo ? String(teamStats.ageTo) : null,
	teamRating: teamStats.teamRating || null,
	teamInfo: teamStats.teamInfo ? mapTeamInfo(teamStats.teamInfo) : null,
	overallAnalytics: teamStats.overallAnalytics || null,
	winLossAnalytics: teamStats.winLossAnalytics || null,
	matchups: teamStats.matchups || null,
	lastFiveMatchups: teamStats.lastFiveMatchups || null,
	teamPlayers: teamStats.teamPlayers ? teamStats.teamPlayers.map(mapTeamPlayer) : [],
	teamStatistics: teamStats.teamStatistics || null,
	dateCreated: teamStats.dateCreated
});

const mapTeamInfo = (teamInfo: TeamInfoDto): TeamInfoDto => ({
	uuid: teamInfo.uuid,
	teamLeagueUuid: teamInfo.teamLeagueUuid,
	organizationUuid: teamInfo.organizationUuid,
	title: teamInfo.title,
	abbreviation: teamInfo.abbreviation || null,
	teamLeagueDistrictUuid: teamInfo.teamLeagueDistrictUuid || null,
	contactFormEmail: teamInfo.contactFormEmail || null,
	description: teamInfo.description || null,
	logos: teamInfo.logos ? teamInfo.logos.map(mapTeamLogo) : [],
	sponsors: teamInfo.sponsors || [],
	managers: teamInfo.managers ? teamInfo.managers.map(mapTeamManager) : [],
	owners: teamInfo.owners ? teamInfo.owners.map(mapTeamOwner) : [],
	locations: teamInfo.locations || [],
	slug: teamInfo.slug,
	captain: teamInfo.captain || null,
	coCaptains: teamInfo.coCaptains || []
});

const mapTeamPlayer = (player: TeamPlayerInfoDto): TeamPlayerInfoDto => ({
	uuid: player.uuid,
	firstName: player.firstName,
	lastName: player.lastName,
	city: player.city,
	stateAbbreviation: player.stateAbbreviation,
	userUuid: player.userUuid,
	gender: player.gender || '',
	singleRating: player.singleRating || null,
	doubleRating: player.doubleRating || null,
	age: player.age || null,
	userImageUrl: player.userImageUrl || null,
	totalGamesWon: player.totalGamesWon || null,
	totalGamesLost: player.totalGamesLost || null,
	totalPointsWon: player.totalPointsWon || null,
	totalPointsLost: player.totalPointsLost || null
});

const mapTeamLogo = (logo: TeamLogoDto): TeamLogoDto => ({
	uuid: logo.uuid,
	url: logo.url,
	isPrimary: logo.isPrimary,
	moduleUuid: logo.moduleUuid
});

const mapTeamManager = (manager: TeamManagerDto): TeamManagerDto => ({
	uuid: manager.uuid,
	moduleFor: manager.moduleFor,
	moduleUuid: manager.moduleUuid,
	userUuid: manager.userUuid,
	firstName: manager.firstName,
	lastName: manager.lastName,
	email: manager.email,
	phone: manager.phone
});

const mapTeamOwner = (owner: TeamOwnerDto): TeamOwnerDto => ({
	uuid: owner.uuid,
	userUuid: owner.userUuid,
	biography: owner.biography,
	firstName: owner.firstName,
	lastName: owner.lastName,
	email: owner.email,
	phone: owner.phone
});
